import { importProvidersFrom } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import NgrxReportsEffect from './effects/ngrx-reports.effect';

export const provideNgrxReports = () => {
    return [importProvidersFrom(EffectsModule.forFeature([NgrxReportsEffect]))];
};
